import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useLandingProductGTM } from '@/fo/api/gtm';
import { cartActions } from '@/fo/store/product';
import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { Product } from '@/fo/ui/landing/product-card/esthederm';
import { staticMediaUrl } from '@/fo/util/image-loader';
import { reachMetrikaGoal } from '@/fo/util/metrics';

import { styles } from './Bundle.styles';

export interface BundleProps {
  product: Product;
}

export function Bundle({ product }: BundleProps) {
  const slots = styles();
  const t = useTranslations();
  const { ref, onSelectItem, viewItemList } = useLandingProductGTM(product);

  return (
    <div
      ref={ref}
      className={slots.base()}
    >
      {viewItemList}
      <div className={slots.info()}>
        <p className={slots.infoNumber()}>
          <span className={slots.infoSmall()}>+</span>
          82
          <span className={slots.infoSmall()}>%</span>
        </p>
        <div className={slots.infoContent()}>
          <p className={slots.infoText()}>Инновация</p>
          <p className={slots.infoDescription()}>
            улучшается
            <br /> качество кожи<sup>1</sup>
          </p>
        </div>
      </div>
      <p className={slots.giftBadge()}>Подарок</p>
      <div className={slots.visual()}>
        <picture className="block h-full">
          <source
            srcSet={staticMediaUrl('landing/ie_intensive_nad/bundle_new5.jpg')}
            media="(min-width: 1024px)"
          />
          <img
            className={slots.image()}
            src={staticMediaUrl('landing/ie_intensive_nad/bundle_sm2.png')}
            alt="Esthederm Intensive NAD+"
          />
        </picture>
      </div>
      <div className={slots.product()}>
        <div className={slots.content()}>
          <h2 className={slots.title()}>{product.heading}</h2>
          <p className={slots.text()}>{product.text}</p>
        </div>
        <div className={slots.priceWrapper()}>
          {product.basePrice && (
            <UiKitPriceBase
              value={product.finalPrice || product.basePrice || 0}
              oldValue={product.basePrice}
              className={slots.price()}
              classNameValue={slots.priceText()}
              classNameOldValue={slots.priceOld()}
            />
          )}
          <div className={slots.buttons()}>
            {product.basePrice && (
              <button
                className={slots.button()}
                onClick={() => {
                  cartActions.addProductsToCart([
                    {
                      sku: product.sku ?? '',
                      quantity: 1,
                      product: {
                        sku: product.sku ?? '',
                        name: product.name || '',
                        brand: product.brand || '',
                        series: product.series || '',
                        volume: product.volume || '',
                        basePrice: product.basePrice || 0,
                        finalPrice: product.finalPrice || null,
                        baseImage: product.baseImage || { src: '', alt: '' }
                      }
                    }
                  ]);
                  reachMetrikaGoal('dobavlenie_v_korzinu');
                }}
              >
                {t('To cart')}
              </button>
            )}
            {product.link && (
              <Link
                href={product.link}
                target="_blank"
                className={slots.buttonSecondary()}
                onClick={() => {
                  onSelectItem();
                  reachMetrikaGoal('perehod_v_kartochku_tovara');
                }}
              >
                {t('more')}
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className={slots.gift()}>
        <p className={slots.giftLabel()}>Подарок</p>
        <p className={slots.giftText()}>
          Миниатюра сыворотки для&nbsp;продления молодости кожи вокруг&nbsp;глаз
          Age&nbsp;Proteom
        </p>
      </div>
    </div>
  );
}
